import React from 'react';

import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import Pagination from '@material-ui/lab/Pagination';

type Props = {
    page: number,
    pages: number,
    handleChangePage: (event: object, page: number) => void,
    limits: Array<JSX.Element>,
};

const PaginationDesktop: React.FC<Props> = ({
    page,
    limits,
    pages,
    handleChangePage,
}) => (
    <Hidden xsDown>
        <Box display="flex"
             justifyContent="space-between">
            <Box display="flex"
                 flexBasis="17%"
                 alignItems="center"
                 justifyContent="space-around">
                {limits}
            </Box>
            <Box display="flex"
                 alignItems="baseline">
                <span>strona</span>
                <Pagination count={pages}
                            page={page ?? 1}
                            onChange={handleChangePage}
                            variant="outlined"
                            shape="rounded"/>
            </Box>
        </Box>
    </Hidden>
);


export default PaginationDesktop;
